import { css } from 'styled-components';
const small = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow:
    0 4px 10px rgb(0 0 0 / 2%),
    0 1px 2px rgb(0 0 0 / 2%);
`;
const medium = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow:
    0 0 3px rgb(0 0 0 / 8%),
    0 8px 24px rgb(0 0 0 / 4%);
`;
const large = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow:
    0 10px 30px rgb(40 50 64 / 12%),
    0 0 3px rgb(0 0 0 / 10%);
`;
const error = css `
  box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.critical10_1};
`;
const warning = css `
  box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.warning10_1};
`;
const success = css `
  box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.positive10_1};
`;
const focus = css `
  box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.mainLight};
`;
// LEGACY SHADOWS - DO NOT USE
const baseShadow = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow:
    0 2px 2px 0 rgb(61 88 128 / 5%),
    0 4px 4px 2px rgb(61 88 128 / 5%),
    0 8px 8px 4px rgb(61 88 128 / 5%);
`;
const baseShadowLight = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow: 0 2px 2px 0 rgb(61 88 128 / 5%);
`;
const baseShadowHover = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow:
    0 2px 2px 0 rgb(61 88 128 / 10%),
    0 4px 4px 2px rgb(61 88 128 / 10%),
    0 8px 8px 4px rgb(61 88 128 / 10%);
`;
const shadowTuna = css `
  /* stylelint-disable-next-line function-disallowed-list */
  box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
`;
export default {
    small,
    medium,
    large,
    error,
    warning,
    success,
    focus,
    // LEGACY SHADOWS - DO NOT USE
    baseShadow,
    baseShadowLight,
    baseShadowHover,
    shadowTuna,
};
